import { useEffect, useState } from "react";
import styled from "styled-components";
import { searchNews } from "actions";
import { Spritz } from "components";
import { Box } from "../box";
import {
  getPanelConfigSchema,
  parseSearchTerms,
  resolveConfig,
} from "../panel-config";

export const ImageContainer = styled(Box)`
  ${({ theme: { colors } }) => `
    position: relative;
    box-sizing: border-box;
    padding: 2vw;
    display: flex;
    flex-direction: column;
    align-content: space-around;
    align-items: flex-start;
    justify-content: space-between;
  `}
`;

const Image = styled.div`
  ${({ background }) => `
  content: ' ';
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-image: url('${encodeURI(background)}');
  background-repeat: no-repeat;
  background-position: 50% 0;
  background-size: cover;
  opacity: 0.5;
  z-index: 0;
`}
`;

export const Headline = styled.span`
  ${({ theme: { colors } }) => `
    z-index: 4;
    mark{
      background: ${colors("link", 0.75)};
      color: ${colors("text")};
      font-size: 2.5vw;
      font-weight: 500;
      line-height: 4vw;
      text-overflow: ellipsis;
    }
  `}
`;

export const Article = styled.span`
  ${({ theme: { colors } }) => `
    font-size: 2vw;
    line-height: 2.25vw;
    z-index: 4;
    mark{
      background: ${colors("background", 0.75)};
      color: ${colors("text")};
    }
  `}
`;

export const News = ({ details }) => {
  const [article, setArticle] = useState({});
  const [articles, setArticles] = useState([]);

  const { searchTerms } = resolveConfig(
    getPanelConfigSchema("news"),
    details?.config
  );
  // Primitive key so the fetch effect only re-runs when the terms actually change
  const termsKey = parseSearchTerms(searchTerms).join(",");

  const getArticle = () => {
    if (articles.length === 0) return;
    setArticle(articles[Math.floor(Math.random() * articles.length)]);
  };

  const doFetch = async () => {
    try {
      // One request covers every term (the API ORs them); empty terms = latest headlines
      setArticles(await searchNews(termsKey));
    } catch (err) {
      // Keep showing the previous articles if a refresh fails (rate limit, offline)
      console.error("News fetch failed", err);
    }
  };

  useEffect(() => {
    doFetch();
    const id = setInterval(doFetch, 1000000);
    return () => clearInterval(id);
  }, [termsKey]);

  useEffect(() => {
    const id = setInterval(getArticle, 30000);
    return () => clearInterval(id);
  }, [articles]);

  useEffect(() => {
    getArticle();
  }, [articles]);

  if (!article) return null;

  return (
    <ImageContainer>
      {article?.urlToImage && <Image background={article.urlToImage} />}
      <Headline>
        <mark>{article?.title}</mark>
      </Headline>
      <Article>
        <Spritz text={article?.description} />
      </Article>
    </ImageContainer>
  );
};
